<template>
    <div v-if="showIcon">
        <span
            class="reports-menu-status-icon__circle"
            @click.stop.prevent="goToCreate"
        >
            <v-icon small color="white">
                mdi-clipboard-text-clock
            </v-icon>
        </span>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'ReportsMenuStatusIcon',
    computed: {
        ...mapGetters({
            todayReportExists: 'ReportsModule/getTodayReportExists',
        }),
        isTrainee() {
            return this.$auth.check() && this.$auth.user().roleName === 'Trainee';
        },
        exists() {
            return !!this.todayReportExists;
        },
        isAfterSix() {
            const now = new Date();
            return now.getHours() >= 18;
        },
        showIcon() {
            // Показуємо значок тільки для стажера після 18:00, якщо звіт НЕ створено
            return this.isTrainee && this.isAfterSix && !this.exists;
        },
    },
    methods: {
        goToCreate() {
            this.$router.push({ name: 'reports.create' }).catch(() => {});
        },
    },
};
</script>

<style scoped>
.reports-menu-status-icon__circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #f44336; /* червоний */
    color: #ffffff; /* біла іконка */
    margin-left: 8px;
    cursor: pointer;
}
</style>
